import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { sectionDefaultV0Schema } from './v0';
import { sectionLegacyDefaultV0Schema } from '../legacy/default';
import { migrateLegacyDefaultToV0 } from '../legacy/migration';

export const DefaultSectionEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: sectionDefaultV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: sectionLegacyDefaultV0Schema, up: migrateLegacyDefaultToV0 }],
});

export type DefaultSection = InferredEntity<typeof DefaultSectionEntitySchema>;
